import React from 'react'
import { Mail, Phone } from 'lucide-react'

function MemberRow({ member }) {
    const mail = String(member.mail || '').trim()
    const phone = String(member.phone || '').trim()

    return (
        <div className="flex flex-col items-center gap-2 text-center md:flex-row md:items-center md:justify-between md:gap-6 md:text-left">
            <div className="min-w-0 md:flex-1">
                <p className="interf text-xl font-semibold leading-tight text-neutral-900">
                    {String(member.name || '').trim()}
                </p>
                {member.rank && (
                    <p className="mt-1 text-[15px] uppercase tracking-[0.18em] text-neutral-500">
                        {member.rank}
                    </p>
                )}
            </div>
            {member.sId && (
                <p className="text-xs tracking-[0.14em] text-neutral-400 md:w-28 md:shrink-0">
                    {member.sId}
                </p>
            )}
            {(mail || phone) && (
                <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-sm md:w-56 md:shrink-0 md:justify-end">
                    {mail && (
                        <a
                            href={`mailto:${mail}`}
                            className="inline-flex items-center gap-1.5 text-neutral-700 underline decoration-neutral-300 underline-offset-4 transition-colors hover:text-red-600"
                        >
                            <Mail size={14} strokeWidth={1.75} />
                            Mail
                        </a>
                    )}
                    {phone && (
                        <a
                            href={`tel:${phone.replace(/\s+/g, '')}`}
                            className="inline-flex items-center gap-1.5 text-neutral-700 transition-colors hover:text-red-600"
                        >
                            <Phone size={14} strokeWidth={1.75} />
                            {phone}
                        </a>
                    )}
                </div>
            )}
        </div>
    )
}

function StateCard({ group }) {
    if (!group) return <StateCardSkeleton />

    return (
        <li className="border-b border-neutral-300/90 py-7 last:border-b-0 md:py-8">
            <div className="grid grid-cols-1 items-start gap-4 text-center md:grid-cols-12 md:gap-8 md:text-left">
                <p className="protest text-[15px] uppercase tracking-[0.22em] text-red-600 md:col-span-3 md:pt-1">
                    {group.state}
                </p>
                <ul className="md:col-span-9">
                    {group.members.map((member, index) => (
                        <li key={member._id || member.sId || `${group.state}-${index}`} className={index > 0 ? 'mt-4 border-t border-neutral-200 pt-4 md:mt-5 md:pt-5' : ''}>
                            <MemberRow member={member} />
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}

export function StateCardSkeleton({ index = 0, members = 1 }) {
    const delay = `${index * 90}ms`

    return (
        <li className="border-b border-neutral-300/70 py-7 last:border-b-0 md:py-8">
            <div className="grid grid-cols-1 items-center justify-items-center gap-4 md:grid-cols-12 md:items-start md:justify-items-start md:gap-8">
                <span
                    className="state-shimmer block h-3 w-28 rounded-sm md:col-span-3 md:mt-2"
                    style={{ animationDelay: delay }}
                />
                <div className="w-full space-y-4 md:col-span-9">
                    {Array.from({ length: members }).map((_, memberIndex) => (
                        <div
                            key={memberIndex}
                            className="flex flex-col items-center gap-2 md:flex-row md:items-center md:justify-between"
                        >
                            <span
                                className="state-shimmer block h-5 w-44 max-w-full rounded-sm"
                                style={{ animationDelay: delay }}
                            />
                            <span
                                className="state-shimmer block h-3 w-16 rounded-sm"
                                style={{ animationDelay: delay }}
                            />
                            <span
                                className="state-shimmer hidden h-3 w-24 rounded-sm md:block"
                                style={{ animationDelay: delay }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </li>
    )
}

export default StateCard
